import React from 'react';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/gDZeneg5vpHUpBQWg8dG3t/taylorcologo.webp';
type LogoProps = {
  /** Rendered height of the wordmark in pixels. */
  height?: number;
  className?: string;
};

/**
 * Taylor Company wordmark.
 *
 * The source artwork is white on a transparent background with generous
 * padding, so it is cropped to the mark and intended for dark surfaces
 * (header, footer).
 */
export function Logo({
  height = 34,
  className = ''
}: LogoProps) {
  const width = height * 3.55;
  return <span className={`relative block overflow-hidden ${className}`} style={{
    height,
    width
  }} role="img" aria-label="Taylor Company" data-id="element-133" data-mp="18n7kn39r6ymj">
      <img src={LOGO_URL} alt="" aria-hidden="true" className="pointer-events-none absolute left-1/2 top-1/2 max-w-none select-none" style={{
      width: width / 0.45,
      transform: 'translate(-50%, -45%)'
    }} loading="eager" decoding="async" data-id="element-134" data-mp="yy7f110qx4zd" />
    </span>;
}